import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackingRobFuelFiguresEditComponent } from '../jacking-rob-fuel-figures-edit/jacking-rob-fuel-figures-edit';
import { JackingRobFuelFiguresPage } from './jacking-rob-fuel-figures';
import { SharedModule } from '../../../shared/shared.module';
import { DailyLogPageModule } from '../../../daily-log/daily-log/daily-log.module';
import { DirectivesModule } from '../../../../directives/directives.module';

@NgModule({
  declarations: [
    JackingRobFuelFiguresPage,
    JackingRobFuelFiguresEditComponent
  ],
  imports: [
    IonicPageModule.forChild(JackingRobFuelFiguresPage),
    SharedModule,
    DailyLogPageModule,
    DirectivesModule,
  ],
})
export class JackingRobFuelFiguresPageModule {}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/jacking-rob-fuel-figures/jacking-rob-fuel-figures/jacking-rob-fuel-figures.module.ts